import { createVNode, defineComponent, h, reactive, render, VNode } from 'vue';
import type { Nullable } from '@mts-fe/types';
import Loading from './Loading.vue';
import type { LoadingProps } from './typing';

export function createLoading(props?: Partial<LoadingProps>, target?: HTMLElement, wait = false) {
  const data = reactive({
    tip: props?.tip || '',
    loading: props?.loading ?? true,
    size: props?.size || 'large',
    absolute: props?.absolute ?? false,
    theme: props?.theme,
  });

  let LoadingWrap: any;
  const getLoadingWrap = () => {
    if (!LoadingWrap) {
      LoadingWrap = defineComponent({
        render() {
          return h(Loading, { ...data });
        },
      });
    }
    return LoadingWrap;
  };

  let vm: Nullable<VNode> = null;
  let container: Nullable<HTMLElement> = null;

  const renderToContainer = () => {
    if (!vm) {
      vm = createVNode(getLoadingWrap());
    }
    if (!container) {
      container = document.createElement('div');
      render(vm, container);
    }
  };

  if (wait) {
    setTimeout(renderToContainer, 0);
  } else {
    renderToContainer();
  }

  const getElement = () => vm?.el as HTMLElement | undefined;

  function close() {
    const el = getElement();
    el?.parentNode?.removeChild(el);
  }

  function open(targetEl: HTMLElement = document.body) {
    const el = getElement();
    if (el) {
      targetEl.appendChild(el);
    }
  }

  function destroy() {
    if (container) {
      render(null, container);
      container = null;
    }
    vm = null;
  }

  if (target) {
    setTimeout(() => {
      const el = getElement();
      if (el) {
        target.appendChild(el);
      }
    }, 0);
  }

  return {
    vm,
    close,
    open,
    destroy,
    setTip: (tip: string) => {
      data.tip = tip;
    },
    setLoading: (loading: boolean) => {
      data.loading = loading;
    },
    get loading() {
      return data.loading;
    },
    get tip() {
      return data.tip;
    },
    get $el() {
      return getElement();
    },
  };
}
